var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.436 24.938 4.804 4.43-.77.84-6.496-5.975v-.466l6.49-5.982.776.804-4.811 4.459a1.5 1.5 0 0 1-.53.331h12.135v1.235H18.899c.198.072.38.182.537.324",
    className: "left-arrow_svg__arrow"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    x: 0.5,
    y: 0.5,
    stroke: "#333",
    rx: 23.5
  })));
};
export default SvgLeftArrow;